const module_name = "service.admin";
const $inject = ["$http"];

class AdminService {
  constructor($http) {
    this.$http = $http;
  }

  load_admin_data() {
    let handleSuccess = function (response) {
      if (!response.data || !response.data.success) {
        return [];
      }
      else {
        return response.data.data;
      }
    };

    let handleError = function (response) {
      return [];
    };

    return this.$http
      .get("/admin/data")
      .then(handleSuccess, handleError);
  }

  load_clinic(clinic_id) {
    let handleSuccess = function (response) {
      if (!response.data || !response.data.success) {
        return handleError(response);
      }
      else {
        return response.data.data;
      }
    };

    let handleError = function (response) {
      return [];
    };

    return this.$http
      .get(`/admin/clinic/${clinic_id}/data`)
      .then(handleSuccess, handleError);
  }

  load_roles() {
    let handleSuccess = function (response) {
      if (!response.data || !response.data.success) {
        return [];
      }
      else {
        return response.data.data;
      }
    };

    let handleError = function (response) {
      return [];
    };

    return this.$http
      .get("/admin/roles")
      .then(handleSuccess, handleError);
  }

  change_password(pharmacist, handleSuccess, handleError) {
    this.$http.post("/admin/profile/change_password", {account_access: pharmacist}).then(handleSuccess, handleError);
  }

  get_refund_reasons() {
    function handleSuccess(response) {
      if (response.data.success) {
        return response.data.data;
      }
      else {
        return handleError(response);
      }
    }

    function handleError(response) {
    }

    return this.$http.get("/admin/referral/get-refund-reasons").then(handleSuccess, handleError);
  }
}

AdminService.$inject = $inject;

export default angular.module(module_name, [])
  .service("AdminService", AdminService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/admin.service.js
 **/